import { gql } from "@apollo/client";

export const SEND_VEHICLE_CONDITION_REPORT = gql`
  mutation sendVehicleConditionReports($bookingId: String!,$bookingScheduleId:String!, $additionalMails: [String]) {
    sendVehicleConditionReports(bookingId: $bookingId, bookingScheduleId:$bookingScheduleId additionalMails: $additionalMails)
  }
`;